import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.scss'
import App from './components/App'

// SETTING UP REDUX STORE
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import reduxThunk from 'redux-thunk'
import reducers from './store/reducers'

// ENHANCING STORE WITH FIREBASE
import { reactReduxFirebase } from 'react-redux-firebase'
import firebase from './services/firebase'

const createStoreWithFirebase = compose(reactReduxFirebase(firebase))(
  createStore
)
const store = createStoreWithFirebase(reducers, {}, applyMiddleware(reduxThunk))

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
)
